import React, { FunctionComponent } from 'react';
import { Entity, FilterDefinition, FilterType } from '../types';
import { FilterProps } from './types';
import { MultiSelectFilter } from './multiSelect';
import { NumericRangeFilter } from './numericRange';
import { DateRangeFilter } from './dateRange';
import { SelectFilter } from './select';

type Props = {
  definition: FilterDefinition;
  values?: Entity[];
  disabled: boolean;
  onChange: (name: string, values: Entity[]) => void;
};

const filterElements: Record<FilterType, FunctionComponent<FilterProps>> = {
  multiSelect: MultiSelectFilter,
  numericRange: NumericRangeFilter,
  dateRange: DateRangeFilter,
  select: SelectFilter,
};

function FilterEntry({ definition, values = [], disabled, onChange }: Props) {
  const { type } = definition;
  const Element = filterElements[type];

  if (!Element) {
    return null;
  }

  return (
    <div className="pb-6" data-test-id={definition.name}>
      <Element definition={definition} values={values} disabled={disabled} onChange={onChange} />
    </div>
  );
}

export { FilterEntry };
